import React from 'react';
import { RotateCw, Phone, Mail } from 'lucide-react';

export const EmailBadge = ({ status }) => {
  const map = {
    sent: 'bg-green-50 text-green-700 border-green-200',
    failed: 'bg-red-600 text-white border-red-600',
  };
  const label = { sent: 'Email sent', failed: 'Email failed' }[status] || 'May have been missed';
  return (
    <span className={`inline-block text-[11px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-sm border ${map[status] || 'bg-amber-50 text-amber-800 border-amber-300'}`}
      data-testid="email-status-badge">{label}</span>
  );
};

export const RetryButton = ({ onClick, busy, testId }) => (
  <button type="button" onClick={onClick} disabled={busy} data-testid={testId}
    className="inline-flex items-center gap-1 text-xs font-semibold text-red-600 hover:text-red-700 disabled:opacity-50">
    <RotateCw className={`w-3.5 h-3.5 ${busy ? 'animate-spin' : ''}`} /> Retry email
  </button>
);

export const ContactLinks = ({ phone, email }) => (
  <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm">
    <a href={`tel:${phone}`} className="inline-flex items-center gap-1 text-neutral-800 hover:text-red-600"><Phone className="w-3.5 h-3.5 text-red-600" />{phone}</a>
    <a href={`mailto:${email}`} className="inline-flex items-center gap-1 text-neutral-800 hover:text-red-600 break-all"><Mail className="w-3.5 h-3.5 text-red-600" />{email}</a>
  </div>
);

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString('en-US', { timeZone: 'America/Denver', dateStyle: 'medium', timeStyle: 'short' }) : '');
export const usd = (cents) => `$${((cents || 0) / 100).toFixed(2)}`;

export const isMissed = (item) => item.email_status !== 'sent';
export const missedBorder = (status) => (
  status === 'failed' ? 'border-red-600 border-l-4' : status === 'sent' ? 'border-neutral-200' : 'border-amber-400 border-l-4'
);
